import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Bookmark, BookmarkCheck } from "lucide-react";

// Logs a prop pick to the user's forward Track Record (realized ROI / calibration).
export function trackPayloadFrom(p) {
  return {
    fixture_id: p.fixture_id,
    player: p.player,
    prop: p.prop,
    prop_key: p.prop_key,
    stat: p.stat,
    line: p.line,
    odd: p.odd ?? null,
    predicted_pct: p.recent?.pct ?? null,
    model_pct: p.model_pct ?? null,
    market_pct: p.market_pct ?? null,
    edge_pct: p.edge_pct ?? null,
    value_pct: p.value_pct ?? null,
    home: p.home,
    away: p.away,
    tournament: p.tournament,
    match_date: p.date,
  };
}

export default function TrackToggle({ p }) {
  const [tracked, setTracked] = useState(false);
  const add = async (e) => {
    e.stopPropagation();
    if (tracked) return;
    try {
      await api.post("/tracked-picks", trackPayloadFrom(p));
      setTracked(true);
      toast.success("Added to Track Record");
    } catch (err) {
      if (err.response?.status === 409) {
        setTracked(true);
        toast.info("Already in your Track Record");
      } else {
        toast.error("Couldn't track this pick");
      }
    }
  };
  return (
    <button
      onClick={add}
      data-testid="track-pick-btn"
      className={
        "flex items-center gap-1 text-xs font-semibold rounded-full px-2.5 py-1 transition-colors shrink-0 " +
        (tracked ? "bg-[#34C759] text-white" : "bg-secondary text-foreground hover:bg-secondary/70")
      }
    >
      {tracked ? <BookmarkCheck className="h-3 w-3" /> : <Bookmark className="h-3 w-3" />}
      {tracked ? "Tracked" : "Track"}
    </button>
  );
}
